const initState = {
    incidents: [],
    incident: null,
    gotoIncident: null,
};

const incidentReducer = (state = initState, action) => {


    switch (action.type) {

        case "RESET_GOTO_INCIDENT":
            return {
                ...state,
                gotoIncident: null,
            };

        case "GOTO_INCIDENT":
            return {
                ...state,
                gotoIncident: action.risk_id,
            };

        case "INCIDENTS":
            return {
                ...state,
                incidents: action.incidents,
            };

        case "INCIDENT":
            return {
                ...state,
                incident: action.incident,
            };
        case "CLOSE_INCIDENT":
            return {
                ...state,
                incident: null,
            };

        default:
            return state;
    }
};

export default incidentReducer;
